import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';

function Result(props) {
  return (
    <CSSTransitionGroup
    className="container"
    component="div"
    transitionName="fade"
    transitionEnterTimeout={2000}
    transitionLeaveTimeout={1500}
    transitionAppear
    transitionAppearTimeout={1500}
    >
    <div className="container-btn result-container">
        <h1 className="result-heading text-center">
            Meet Your Match!
        </h1>

        <div className="row questionmargin result-border">
            <div className="col-md-4 result-image">
                <img src={props.shadeImage} className="img-fluid" />
            </div>
            <div className={`col-md-8 bg-${props.shadeColor} result-text text-center`}>
                <h2>Your perfect match foundation shade is:</h2>
                <p className="result-shadename">{props.shadeResult}</p>
                <p className="result-desc">Use the brush designed for your foundation, then set with a hydrating setting spray!</p>
                <a href={props.shadeLink} target="_BLANK">
                    <span className="button is-primary">
                        Get It Now
                    </span>
                </a>
            </div>
        </div>

        <div className="why-card">
          <h1 className="result-heading text-center">
              This is your perfect match because...
          </h1>
          <div className="row">
            <div className="col-md-4 text-center">
              <span class="circle">1</span>
              <p>Your desired coverage is</p>
              <h3>{ props.answerOne }</h3>
            </div>
            <div className="col-md-4 text-center">
              <span class="circle">2</span>
              <p>Your desired finish is</p>
              <h3>{ props.answerTwo }</h3>
            </div>
            <div className="col-md-4 text-center">
              <span class="circle">3</span>
              <p>You blend foundation with your</p>
              <h3>{ props.answerThree }</h3>
            </div>
          </div>
        </div>

        <h1 className="result-heading text-center">
            And make sure you have these essentials too!
        </h1>

        <div className="row product-card">
          <div className="col-md-4 result-image result-image__brush">
            <img src={ props.brushImage } className="img-fluid" />
          </div>
          <div className="col-md-8 product-card__text">
            <h3>{ props.brush }</h3>
            <p>Blend in your foundation effortlessly and easily with this specially-designed brush.</p>
            <a href={ props.brushLink } target="_BLANK">
                <span className="button is-dark">
                    Get It Now
                </span>
            </a>
          </div>
        </div>

        <div className="row product-card">
          <div className="col-md-4 result-image result-image__spray">
            <img src="http://cdn.shopify.com/s/files/1/0247/5376/6482/products/settingspray_800x800@2x.png" className="img-fluid" />
          </div>
          <div className="col-md-8 product-card__text">
            <h3>Setting Spray</h3>
            <p>Mist on this weightless spray to give your makeup serious staying power.</p>
            <a href="https://bovanticosmetics.com/collections/setting-spray-powder/products/setting-spray" target="_BLANK">
                <span className="button is-dark">
                    Get It Now
                </span>
            </a>
          </div>
        </div>

        <div className="btnHolder btn-fixed sticky wrapper buttons fixed">
            <div onClick={ props.onBackSelected } className="back">
                <a aria-label="Go to previous step" className="btnBack">
                    <span className="btn-circle text-center">Start Over</span>
                </a>
            </div>
        </div>
    </div>
    </CSSTransitionGroup>
  );
}

Result.propTypes = {
  shadeResult: PropTypes.string.isRequired,
  shadeColor: PropTypes.string.isRequired,
  shadeLink: PropTypes.string.isRequired,
  shadeImage: PropTypes.string.isRequired,
  brushImage: PropTypes.string.isRequired,
  brushLink: PropTypes.string.isRequired,
  brush: PropTypes.string.isRequired,
  answerOne: PropTypes.string.isRequired,
  answerTwo: PropTypes.string.isRequired,
  answerThree: PropTypes.string.isRequired,
  onBackSelected: PropTypes.func.isRequired
};

export default Result;